import React, { useState } from "react";
import { Modal, Button } from "rsuite";
import { removeUserFromBucketApi } from "../../../redux/slice/monitor/monitor.api";
import { ErrorToast, SuccessToast } from "../Alert";

interface Props {
    open: boolean;
    props: {
        walletKey: string;
        bucketId: string | undefined;
    } | null;
    handleClose: () => void;
    handleComplete: () => void;
}

const RemoveUserModal = ({
    open,
    props,
    handleClose,
    handleComplete,
}: Props) => {
    const [loading, setLoading] = useState(false);

    const handleRemove = async () => {
        if (!props?.bucketId || !props?.walletKey) return;

        setLoading(true);
        try {
            const payload = { wallet_key: props.walletKey };

            await removeUserFromBucketApi(props.bucketId, payload);
            SuccessToast(`User removed successfully`);
            handleComplete();
        } catch (error) {
            ErrorToast("Couldn't Complete... Something Went Wrong");
            console.error("Validation error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={handleClose} size="sm">
            <Modal.Header>
                <Modal.Title>Confirm Removal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to remove this user from the bucket?
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose} appearance="subtle">
                    Cancel
                </Button>
                <Button
                    onClick={handleRemove}
                    appearance="primary"
                    color="red"
                    className="bg-red-700"
                    loading={loading}
                >
                    Remove
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RemoveUserModal;
